'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.getIntro = getIntro;
var GET_CU_INTRO = 'bp/cu/detail/GET_CU_INTRO';
var GET_CU_INTRO_SUCCESS = 'bp/cu/detail/GET_CU_INTRO_SUCCESS';
var GET_CU_INTRO_FAIL = 'bp/cu/detail/GET_CU_INTRO_FAIL';

var initialState = {
    intro: {},
    images: null,
    cuHashId: "",
    loading: true
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_CU_INTRO:
            return _extends({}, state, {
                intro: {},
                images: null,
                cuHashId: action.cuHashId,
                loading: true
            });
        case GET_CU_INTRO_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                intro: action.result.data.data,
                images: action.result.data.data.images,
                loading: false
            });
        default:
            return state;
    }
}
function getIntro(cuHashId) {
    return {
        types: [GET_CU_INTRO, GET_CU_INTRO_SUCCESS, GET_CU_INTRO_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/cu_school/intro?schoolHashId=' + cuHashId);
            }

            return promise;
        }(),
        cuHashId: cuHashId
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cu/cuIntro.js
// module id = 459
// module chunks = 0